export enum ErrorEnum {
    EMAIL_NOT_CONFIRMED = 'EMAIL_NOT_CONFIRMED',
    WRONG_LOGIN_OR_PASSWORD = 'WRONG_LOGIN_OR_PASSWORD'
}